<div class="header" [style.color]="titleColor">
    <i [className]="icon" class="notranslate" translate="no">{{iconBody}}</i> <span>{{title}}</span>
</div>
<mat-divider></mat-divider>
